import './styles.css';
import React, { useEffect } from "react";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCodepen, faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../firebase';
library.add(faCodepen, faGithub, faLinkedin); 
// async function doSetTimeout(i) {
//     new Promise((resolve, reject) => {
//         setTimeout(function() { resolve() }, 2000);

//     })
//   }
function AnimatedListRender() {
// Cambios after render (EFECTOS "SECUNDARIOS")
    useEffect(() => {
        const texts = document.querySelectorAll(".lazyList li > span.text");
    texts.forEach((text, i) => {text.setAttribute("id",`lazyList-text-${i}`);});
    texts.forEach((text, i ) => {
        document.getElementById(text.id).style.animation = `fadeIn .5s var(--animation-timing-3) ${i + 3}s 1 both normal`;
    });   
    const items = document.querySelectorAll('.lazyList li > span.divider');
    items.forEach((item, i) => {item.setAttribute("id", `lazyList-item-${i}`);});
    items.forEach((item, i) => {
        document.getElementById(item.id).style = `animation: lineGrow 1s linear ${i+3}s 1 both normal;`
    })
    })
}




function SocialMedia(props) {
    const medias = props.medias;
    return [
        <article key={1} className='card info socialMedia'>
            {
                medias.map((media, i) => 
                    <div key={i} className='socialMediaLink'>
                        <a key={i} onClick={(u) => {logEvent(analytics, "select_item", {item_list_id: i, item_list_name: `${media.name} profile`})}} href={media.link} target="_blank" rel="noreferrer">{media.icon}</a>
                    </div>
                    )
            }
        </article>
    ]
}


function Home() {
    const medias = [
        {
            name: "Codepen",
            link: "https://codepen.io/Fcanalejo",
            icon: <FontAwesomeIcon icon={faCodepen} className="instagram" />
        },
        {
            name: "Github",
            link: "https://github.com/FragnaroK",
            icon: <FontAwesomeIcon icon={faGithub} className="github" />
        },
        {
            name: "LinkedIn",
            link: "https://www.linkedin.com/in/franco-canalejo/",
            icon: <FontAwesomeIcon icon={faLinkedin} className="linkedin" />
        },
        
    ]
    // AnimatedCardRender();
    AnimatedListRender();
    return [
        <div key={1} className="container">

            <div className="mediaContainer">
                <SocialMedia medias={medias}></SocialMedia>
            </div>
            <div className='funContainer'>
                <section className="presentation-text slideInLeft">
                    <h1>Hey there, <br /> I'm <span>Franco</span> </h1>
                    <ul className="lazyList">
                        <li><span className="text">Junior Web Developer</span> <span className='divider'></span></li>
                        <li><span className="text">22 years old</span> <span className='divider'></span></li>
                    </ul>
                </section>
                <section className="welcoming-text slideInRight">
                    <h1>Welcome <br /> to my <br /> <span>website</span></h1>
                </section>
            </div>
        </div>
    ];
}



export default Home;